module.exports = __webpack_public_path__ + "static/media/KohinoorBangla-Medium.23cb188b.svg";